var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"Email","placeholder":"Informe seu email","outlined":"","hide-details":"","inputmode":"email"},on:{"keyup":_vm.onChange},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})}
var staticRenderFns = []

export { render, staticRenderFns }